import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import CtaButton from 'components/essentials/Cta/CtaButton';
import SingleCollectionCards from 'components/consumer/SingleCollectionCards/SingleCollectionCards';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import Grid4 from 'components/icons/Grid4';
import { colorWhite, colorGrayLight8 } from 'styles/layout/colors';
import isExternalLink from 'commons/isExternalLink';
import getSofaBuilderLink from 'commons/getSofaBuilderLink';
import useScreen from 'hooks/useScreen';
import ModularSofasCollectionPlaceholder from './ModularSofasCollectionPlaceholder';
import ModularProductCard from './ModularProductCard';
const ModularSofasCollection = t0 => {
  const $ = _c(63);
  const {
    collection: t1,
    className: t2,
    collectionIndex
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const collection = t3;
  const className = t2 === undefined ? "" : t2;
  const {
    isMobile
  } = useScreen();
  const {
    products: t4,
    name: t5,
    id,
    description: t6,
    image: t7,
    productLink: t8,
    link: t9
  } = collection;
  let t10;
  if ($[2] !== t4) {
    t10 = t4 === undefined ? [] : t4;
    $[2] = t4;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const products = t10;
  const name = t5 === undefined ? "" : t5;
  const description = t6 === undefined ? "" : t6;
  const image = t7 === undefined ? "" : t7;
  const productLink = t8 === undefined ? "" : t8;
  const link = t9 === undefined ? "" : t9;
  let t11;
  if ($[4] !== products) {
    t11 = products.map(_temp);
    $[4] = products;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const bundleProductIds = t11;
  let t12;
  if ($[6] !== products) {
    t12 = [...products].sort(_temp2);
    $[6] = products;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  const sortedProducts = t12;
  let t13;
  if ($[8] !== name || $[9] !== productLink) {
    t13 = () => {
      const sofaBuilderLink = getSofaBuilderLink(name, `/modular/${productLink}/`);
      if (isExternalLink(sofaBuilderLink)) {
        window.open(sofaBuilderLink);
      } else {
        window.location.href = sofaBuilderLink;
      }
    };
    $[8] = name;
    $[9] = productLink;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  const onBuildClicked = t13;
  const t14 = `collection-${id}`;
  const t15 = `flex overflow-hidden relative no-underline flex-col px-0 py-6 md:h-auto md:p-0 [&_>_*]:flex-1 ${className}`;
  let t16;
  if ($[11] !== name) {
    t16 = <h2 className="text-2xl font-bold text-gray mb-0 md:text-[clamp(1.75rem,5.2vw,2.5rem)] md:leading-[clamp(2.25rem,6.25vw,3rem)] md:tracking-[.0125rem] md:font-bold">{name}</h2>;
    $[11] = name;
    $[12] = t16;
  } else {
    t16 = $[12];
  }
  let t17;
  if ($[13] !== description) {
    t17 = <div className="text-sm mb-6 mt-2 md:block">{description}</div>;
    $[13] = description;
    $[14] = t17;
  } else {
    t17 = $[14];
  }
  let t18;
  if ($[15] !== collectionIndex || $[16] !== image || $[17] !== isMobile) {
    t18 = isMobile && <div className="items-center flex justify-center max-[767px]:pt-5 md:flex-1 md:p-[1.7rem] md:max-w-[calc(100vw_-_350px)] max-[1200px]:md:max-w-[calc(100vw_-_500px)] [&>img]:max-[767px]:max-h-full [&>img]:max-[767px]:relative [&>img]:max-[767px]:top-[20%] [&>img]:max-[767px]:w-auto"><JBImage sizes="70w" src={image} fm="auto" bg={(collectionIndex + 1) % 2 === 0 ? colorGrayLight8 : colorWhite} /></div>;
    $[15] = collectionIndex;
    $[16] = image;
    $[17] = isMobile;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] !== collection || $[20] !== productLink || $[21] !== sortedProducts) {
    let t20;
    if ($[23] !== collection || $[24] !== productLink) {
      t20 = product => <div key={`${product.id}-${product.slug}`} className="max-[767px]:!flex-shrink-0 max-[767px]:!mr-[.3rem] max-[767px]:!max-w-[110px] max-[767px]:!w-[110px] max-[767px]:!flex [&>span]:max-[767px]:!flex [&>span]:max-[767px]:!w-full max-[767px]:bg-gray-light8"><ModularProductCard product={product} overrideProductState={collection} displayType="product" overrideLink={`/modular/${productLink}/`} /></div>;
      $[23] = collection;
      $[24] = productLink;
      $[25] = t20;
    } else {
      t20 = $[25];
    }
    t19 = sortedProducts.map(t20);
    $[19] = collection;
    $[20] = productLink;
    $[21] = sortedProducts;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[26] !== t19) {
    t20 = <div className="flex flex-row flex-nowrap mb-4 w-full max-[767px]:overflow-x-scroll max-[767px]:mt-4 max-[767px]:mx-0 max-[767px]:mb-2"><div className="max-[767px]:flex max-[767px]:flex-row max-[767px]:flex-nowrap max-[767px]:w-screen max-[767px]:overflow-x-scroll [&::-webkit-scrollbar]:max-[767px]:appearance-none [&::-webkit-scrollbar]:max-[767px]:w-0 [&::-webkit-scrollbar]:max-[767px]:h-0 [&::-webkit-scrollbar]:max-[767px]:hidden md:grid md:gap-[10px] md:grid-cols-[repeat(auto-fit,minmax(130px,25%)_)] md:w-full">{t19}</div></div>;
    $[26] = t19;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Grid4 width={20} height={20} fill={colorWhite} />;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== name || $[30] !== onBuildClicked) {
    t22 = <CtaButton className="w-full mb-4 md:w-auto md:mb-0 md:mt-4" styling="solid-button" color="brand" block={true} onClick={onBuildClicked}>{t21} Build your own {name}</CtaButton>;
    $[29] = name;
    $[30] = onBuildClicked;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18 || $[35] !== t20 || $[36] !== t22) {
    t23 = <div className="items-start flex flex-col md:flex-[0.5] md:px-2 md:py-20">{t16}{t17}{t18}{t20}{t22}</div>;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
    $[35] = t20;
    $[36] = t22;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== collectionIndex || $[39] !== image || $[40] !== isMobile) {
    t24 = !isMobile && <div className="items-center flex justify-center max-[767px]:pt-5 md:flex-1 md:p-[1.7rem] md:max-w-[calc(100vw_-_350px)] max-[1200px]:md:max-w-[calc(100vw_-_500px)] [&>img]:max-[767px]:max-h-full [&>img]:max-[767px]:relative [&>img]:max-[767px]:top-[20%] [&>img]:max-[767px]:w-auto"><JBImage width={1000} src={image} fm="auto" bg={(collectionIndex + 1) % 2 === 0 ? colorGrayLight8 : colorWhite} /></div>;
    $[38] = collectionIndex;
    $[39] = image;
    $[40] = isMobile;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t23 || $[43] !== t24) {
    t25 = <FixedWidthContainer className="!w-full flex flex-col md:flex-row max-[1200px]:md:justify-between">{t23}{t24}</FixedWidthContainer>;
    $[42] = t23;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  const t26 = `Pre-configured ${name} options`;
  let t27;
  if ($[45] !== t26) {
    t27 = <h3 className="text-xl font-bold m-0 px-2 py-3 text-left max-[767px]:text-lg max-[767px]:font-bold max-[767px]:mt-10 max-[767px]:p-0">{t26}</h3>;
    $[45] = t26;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <ModularSofasCollectionPlaceholder />;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  let t29;
  if ($[48] !== bundleProductIds || $[49] !== link) {
    t29 = <SuspenseWithLoader fallback={t28}><SingleCollectionCards slug={link} skipProductIds={bundleProductIds} modifier="modular" /></SuspenseWithLoader>;
    $[48] = bundleProductIds;
    $[49] = link;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] !== t27 || $[52] !== t29) {
    t30 = <FixedWidthContainer className="!w-full flex flex-col md:flex-row max-[1200px]:md:justify-between"><div className="pb-20 w-full">{t27}{t29}</div></FixedWidthContainer>;
    $[51] = t27;
    $[52] = t29;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== t25 || $[55] !== t30) {
    t31 = <div>{t25}{t30}</div>;
    $[54] = t25;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== t15 || $[58] !== t31) {
    t32 = <div className={t15}>{t31}</div>;
    $[57] = t15;
    $[58] = t31;
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== t14 || $[61] !== t32) {
    t33 = <div id={t14} className="scroll-mt-[54px] min-h-[700px] md:min-h-[1000px]">{t32}</div>;
    $[60] = t14;
    $[61] = t32;
    $[62] = t33;
  } else {
    t33 = $[62];
  }
  return t33;
};
ModularSofasCollection.propTypes = {
  collection: PropTypes.shape({
    id: PropTypes.number,
    path: PropTypes.string
  }),
  className: PropTypes.string,
  collectionIndex: PropTypes.number
};
export default React.memo(ModularSofasCollection);
function _temp(p) {
  return p.id;
}
function _temp2(a, b) {
  if (a.name.toLowerCase().includes("slipcovered") && !b.name.toLowerCase().includes("slipcovered")) {
    return -1;
  }
  if (!a.name.toLowerCase().includes("slipcover") && b.name.toLowerCase().includes("slipcover")) {
    return 1;
  }
  return 0;
}